import BaseRepository from './base.repository';

class AuthRepository extends BaseRepository {
  constructor() {
    super('/auth');
  }

  authorizePatient(patientMainUnique) {
    return this.client.get(`/authorize/${patientMainUnique}`);
  }

  getMe() {
    return this.client.get('/me');
  }
}

export default new AuthRepository();
